import { render, staticRenderFns } from "./AvatarRounding.vue?vue&type=template&id=005a5310"
import script from "./AvatarRounding.vue?vue&type=script&lang=js"
export * from "./AvatarRounding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports